
const mapItemChoiceItemPrices = (itemChoiceItems, menuItemChoiceItems) => {
  let result = 0;

  if (!itemChoiceItems || !menuItemChoiceItems) return result;

  itemChoiceItems.forEach(itemChoiceItem => {
    const { id, qty, itemChoices } = itemChoiceItem
    const menuItemChoiceItem = menuItemChoiceItems.find(i => i.id === id);
    if (!menuItemChoiceItem) return;
    const { menuItemChoices } = menuItemChoiceItem
    result += menuItemChoiceItem.price * qty;
    result += mapItemChoicesToPrices(itemChoices, menuItemChoices);
  })

  return result;
}

const mapItemChoicesToPrices = (itemChoices, menuItemChoices) => {
  let result = 0;

  if (!itemChoices || !menuItemChoices) return result;

  itemChoices.forEach(itemChoice => {
    const { id, itemChoiceItems } = itemChoice
    const menuItemChoice = menuItemChoices.find(i => i.id === id);
    if (!menuItemChoice) return;
    const { menuItemChoiceItems } = menuItemChoice;
    result += mapItemChoiceItemPrices(itemChoiceItems, menuItemChoiceItems);
  })

  return result;
}

export default mapItemChoicesToPrices